<template>
  <div
    class="background pa-3"
    >
    <template
      v-for="result in results"
      >
      <property-card
        :property="result"
        class="mb-3"
        search
        @openModal="openModal"
        ></property-card>
    </template>

    <v-pagination
      :length="pages"
      v-model="page"
      ></v-pagination>
  </div>
</template>

<script>
import { AgencyResults } from '@/graphql/queries/searches'

import PropertyCard from '@/components/properties/Card'
import Results from '@/components/matches/Results'

export default {
  data: () => ({
    results: [],
    pages: 1,
    page: 1
  }),

  created () {
    this.fetchResults ()
  },

  watch: {
    page () {
      this.fetchResults()
    }
  },

  methods: {
    fetchResults () {
      this.$apollo.query({
        query: AgencyResults,
        variables: {
          page: this.page
        },
        fetchPolicy: 'no-cache'
      }).then ( res => {
        this.results = res.data.agencyResults.properties
        this.pages = res.data.agencyResults.pages
      })
    },
  },

  components: { PropertyCard }
}
</script>
